import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppGestion = Loadable(lazy(() => import('./view/Usuarios')))
const AppNuevo = Loadable(lazy(() => import('./view/registro/UsuarioRegistro')))
const AppActualizar = Loadable(lazy(() => import('./view/actualizar/UsuarioActualizar')))

export const usuariosRoutesMap = {
  gestion: {
    path: '/usuarios/gestion',
    name: 'Gestión Usuarios',
    actionSecure: 'administrar',
  },
  nuevo: {
    path: '/usuarios/nuevo',
    name: 'Nuevo Usuario',
  },
  modificar: {
    path: `/usuarios/modificar`,
    name: 'Modificar Usuario',
  },
}

const usuarioRoutes = [
  {
    path: usuariosRoutesMap.gestion.path,
    element: <AppGestion />,
    auth: authRoles.admin,
  },
  {
    path: usuariosRoutesMap.nuevo.path,
    element: <AppNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${usuariosRoutesMap.modificar.path}/:id`,
    element: <AppActualizar />,
    auth: authRoles.admin,
  },
]

export default usuarioRoutes
